import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {WithStyles, withStyles} from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import get from 'lodash/get';
import {MouseEvent, useState} from 'react';
import {WithTranslation, withTranslation} from 'react-i18next';
import {RouteComponentProps} from 'react-router';
import {NavLink, withRouter} from 'react-router-dom';

import EnumLanguage from 'src/Locale/EnumLanguage';
import {getSupportedLanguages} from 'src/Locale/getSupportedLanguages';

import {languageMenuStyles} from './languageMenuStyles';

const LanguageMenu = (props: WithTranslation & WithStyles & RouteComponentProps) => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const changeLanguage = (language: EnumLanguage) => {
		props.i18n.changeLanguage(language).then(() => setAnchorEl(null));
	};

	const handleClose = () => setAnchorEl(null);
	const withoutCurrent = getSupportedLanguages().filter((lang) => lang !== props.i18n.language);

	return (
		<div className={props.classes.root}>
			<Button
				aria-controls="lang-menu"
				aria-haspopup="true"
				onClick={handleClick}
				className={props.classes.button}
				color="inherit"
			>
				{props.i18n.language}
				<ExpandMoreIcon />
			</Button>
			<Menu
				id="language-menu"
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				onClose={handleClose}
				PaperProps={{
					className: props.classes.menu,
				}}
			>
				{withoutCurrent.map((lang) => (
					<MenuItem
						component={NavLink}
						to={get(props, 'location.pathname', '').replace(props.i18n.language, lang)}
						key={lang}
						onClick={() => changeLanguage(lang)}
						className={props.classes.link}
					>
						{lang.toUpperCase()}
					</MenuItem>
				))}
			</Menu>
		</div>
	);
};

export default withRouter(withStyles(languageMenuStyles)(withTranslation('navigation')(LanguageMenu)));
